<template>
  <div id="screen" class="component-screen footer-hidden m-0 p-0">
    <Loader v-if="loading && classSection" cover/>
    <div v-else class="vx-row lg:h-full m-0 relative">
      <div class="vx-col panels main-panel h-screen lg:h-full sm:h-1/2 flex-1 sm:w-1/1 p-0">
        <MainPanel
          :countLearningPercent="countLearningPercent"
          :currentCourseOutlineUnit="currentCourseOutlineUnit"
          :currentStudentUnitTest="currentStudentUnitTest"
          :currentVdoSetTopic="currentVdoSetTopic"
          :examMode="examMode"
          :keepCounting="keepCounting"
          :mainPanelMode="mainPanelMode"
          :classSection="classSection"

          :setDoingExam="setDoingExam"
          :setNewStudentUnitTestToCourseOutlineUnits="setNewStudentUnitTestToCourseOutlineUnits"
          :sidePanelActive="sidePanelActive"
          :startLearning="startLearning"
          :setTriggerLoading="setTriggerLoading"
          :toggleSidePanel="toggleSidePanel"

          :isBigScreen="isBigScreen"
        >
        </MainPanel>
        <BottomPanel :class-section="classSection"
                     :course-outline-units="courseOutlineUnits"
                     :student="student"
                     :teacher="teacher"
                     :currentCourseOutlineUnit="currentCourseOutlineUnit"

                     :courseOutlineUnitLoading="courseOutlineUnitLoading"
                     :handlerStartTestClick="handlerStartTestClick"
                     :handlerTopicClick="handlerTopicClick"
                     :sidePanelActive="sidePanelActive"
                     :triggerLoading="triggerLoading"
                     @toggleSidePanel="toggleSidePanel"
                     :isBigScreen="isBigScreen"
        >
        </BottomPanel>
      </div>

      <SidePanel v-if="isBigScreen"
        :courseOutlineUnitLoading="courseOutlineUnitLoading"
        :courseOutlineUnits="courseOutlineUnits"
        :handlerStartTestClick="handlerStartTestClick"
        :handlerTopicClick="handlerTopicClick"
        :sidePanelActive="sidePanelActive"
        :triggerLoading="triggerLoading"
        @toggleSidePanel="toggleSidePanel"
      >
      </SidePanel>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import EventBus from '@/event-bus';

import MainPanel from "./MainPanel";
import SidePanel from "./SidePanel";
import BottomPanel from "./BottomPanel";
import ClassSection from "@/store/modules/courses/class-section/index";
import VdoSetTopic from "@/store/modules/vdo-set/vdo-set-topic/index";
import {createNamespacedHelpers} from "vuex";

if (!store.state.ClassSection) store.state.registerModule(`ClassSection`, ClassSection);
if (!store.state.VdoSetTopic) store.state.registerModule(`VdoSetTopic`, VdoSetTopic);

const {
  mapActions: mapClassSectionActions,
} = createNamespacedHelpers(`ClassSection`);
const {
  mapActions: mapVdoSetTopicActions,
} = createNamespacedHelpers(`VdoSetTopic`);

export default {
  components: {
    MainPanel,
    SidePanel,
    BottomPanel,
    Loader: () => import('@/components/common-ui/loader-block/index.vue'),
  },
  computed: {
    student() {
      if (this.studentEnrollDetail) {
        return this.studentEnrollDetail.student;
      }
      return null;
    },
    teacher() {
      if (this.classSection) {
        return this.classSection.courseOutlineRegistration.teacher;
      }
      return null;
    },
  },
  data() {
    return {
      loading: true,
      courseOutlineUnitLoading: true,
      studentEnrollDetailId: null,
      classSectionId: null,
      classSection: null,
      courseOutlineUnits: [],
      vdoSetTopics: [],
      sidePanelActive: true,

      //FOR VIDEO PANEL
      currentVdoSetTopic: null,
      currentVdoSetTopicIndex: null,
      keepCounting: true,
      secondToUpdateStudentLearnTime: 10,

      //FOR PRE & POST TEST PANEL
      doingExam: false,
      examMode: '',
      currentStudentUnitTest: null,
      currentStudentUnitTestIndex: null,
      studentUnitPreTests: [],
      studentAnswers: [],

      //FOR VIDEO & PRE & POST TEST PANEL
      mainPanelMode: 'cover',
      currentCourseOutlineUnit: null,
      currentCourseOutlineUnitIndex: null,
      triggerLoading: false,

      isBigScreen: true,
    }
  },
  methods: {
    ...mapClassSectionActions({
      getClassSectionForLearning: 'getClassSectionForLearning',
    }),
    ...mapVdoSetTopicActions({
      getVdoSetTopicsByFilter: 'getVdoSetTopicsByFilter',
    }),
    //---------------------------------- VDO PANEL FUNCTION ----------------------------------
    async countLearningPercent(/*counter*/) {
      //calculate learn percent
      let currentLearnTime = this.currentVdoSetTopic.studentTopicLearn.learnTime;
      let newLearnTime = currentLearnTime + 1;
      let vdoLength = this.currentVdoSetTopic.vdoLength;
      let percent = Math.floor((newLearnTime / vdoLength) * 100);
      if (percent > 100) {
        percent = 100;
      }

      //set new percent to studentTopicLearn in courseOutlineUnit
      this.setNewLearnTimeToCourseOutlineUnit(newLearnTime, percent);
      if (percent >= 100) {
        //update StudentTopicLearnTime and stop counting
        this.keepCounting = false
        // await this.updateStudentTopicLearnTime();
      }/* else if (counter === this.secondToUpdateStudentLearnTime) {
        //update StudentTopicLearnTime every 10 sec
        await this.updateStudentTopicLearnTime();
      }*/
    },
    async updateStudentTopicLearnTime() {
      const studentTopicLearn = this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
        .vdoSetUnit
        .vdoSetTopics[this.currentVdoSetTopicIndex]
        .studentTopicLearn;
      const studentUnitLearn = this.courseOutlineUnits[this.currentCourseOutlineUnitIndex].studentUnitLearn;

      const payload = {
        studentTopicLearnId: studentTopicLearn.id,
        studentUnitLearnId: studentUnitLearn.id,
        studentTopicLearnInput: {
          learnTime: studentTopicLearn.learnTime,
          learnPercent: studentTopicLearn.learnPercent,
        },
        studentUnitLearnInput: {
          totalLearnTime: studentUnitLearn.totalLearnTime,
          learnPercent: studentUnitLearn.learnPercent,
        },
      };
      await this.updateStudentTopicAndUnitLearn(payload);
    },
    setNewLearnTimeToCourseOutlineUnit(newLearnTime, percent) {
      //update student Topic Learn
      this.currentVdoSetTopic.studentTopicLearn.learnTime = newLearnTime;
      this.currentVdoSetTopic.studentTopicLearn.learnPercent = percent;

      this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
        .vdoSetUnit
        .vdoSetTopics[this.currentVdoSetTopicIndex]
        .studentTopicLearn.learnTime = newLearnTime;
      this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
        .vdoSetUnit
        .vdoSetTopics[this.currentVdoSetTopicIndex]
        .studentTopicLearn.learnPercent = percent;

      //update student Unit Learn
      let newUnitLearnTime = this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
        .studentUnitLearn.totalLearnTime + 1;
      if (newUnitLearnTime > this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
        .vdoSetUnit.totalVdoLength) {
        newUnitLearnTime = this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
          .vdoSetUnit.totalVdoLength;
      }
      let totalUnitVdoLength = this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
        .vdoSetUnit.totalVdoLength;
      let unitPercent = Math.floor((newUnitLearnTime / totalUnitVdoLength) * 100);
      if (unitPercent > 100) {
        unitPercent = 100;
      }
      this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
        .studentUnitLearn.totalLearnTime = newUnitLearnTime;
      this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
        .studentUnitLearn.learnPercent = unitPercent;
    },
    //---------------------------------- PRE & POST TEST PANEL FUNCTION ----------------------------------
    handlerStartTestClick({unit, examMode}) {

      if (this.examMode !== examMode
        || !this.currentStudentUnitTest
        || this.currentStudentUnitTest.id !== unit.studentUnitTest.id) {
        if (this.doingExam) {
          const acceptLost = confirm(this.$t(`virtual-class.confirm-quit-${examMode}`));
          if (acceptLost === true) {
            this.clearVdoPanelVariable();
            this.currentCourseOutlineUnit = unit;
            this.currentCourseOutlineUnitIndex = this.courseOutlineUnits.findIndex(item => item.id === unit.id);
            this.currentStudentUnitTest = unit.studentUnitTest;
            this.mainPanelMode = 'test'
            this.examMode = examMode;
            /*this.setCurrentCourseOutlineUnit(unit);
            this.setCurrentStudentUnitTest(unit);
            this.startPretest();*/
          }
        } else {
          this.clearVdoPanelVariable();
          this.currentCourseOutlineUnit = unit;
          this.currentCourseOutlineUnitIndex = this.courseOutlineUnits.findIndex(item => item.id === unit.id);
          this.currentStudentUnitTest = unit.studentUnitTest;
          this.mainPanelMode = 'test'
          this.examMode = examMode;
          /*this.setCurrentCourseOutlineUnit(unit);
          this.setCurrentStudentUnitTest(unit);
          this.startPretest();*/
        }

      } /*else {
        console.log('dup')
      }*/

    },
    startLearning(unit) {
      let firstTopic = unit.vdoSetUnit.vdoSetTopics;
      if (firstTopic && firstTopic.length > 0) {
        this.handlerTopicClick({unit, topic: firstTopic[0]});
      }
    },
    setDoingExam(doingExam) {
      this.doingExam = doingExam;
    },
    setNewStudentUnitTestToCourseOutlineUnits(studentUnitTest) {
      this.currentCourseOutlineUnit.studentUnitTest = studentUnitTest;
      this.currentStudentUnitTest = studentUnitTest;

      this.courseOutlineUnits[this.currentCourseOutlineUnitIndex].studentUnitTest = studentUnitTest;
    },
    //---------------------------------- SIDE PANEL FUNCTION ----------------------------------
    toggleSidePanel(toggle) {
      this.sidePanelActive = toggle;
    },
    handlerTopicClick({topic, unit}) {
      // console.log('unit',unit);
      // console.log('topic',topic);
      this.clearUniTestPanelVariable();
      //set current currentCourseOutlineUnit && currentVdoSetTopic
      this.setCurrentCourseOutlineUnit(unit);
      this.setCurrentVdoSetTopic(topic);

      //if complete learning then dont count percent
      this.keepCounting = false;
      /*if (this.currentVdoSetTopic.vdoLength > this.currentVdoSetTopic.studentTopicLearn.learnTime) {
        this.keepCounting = true;
      } else {
        this.keepCounting = false;
      }*/

      //show video panel
      this.mainPanelMode = 'vdo';
    },
    //---------------------------------- LOCAL FUNCTION ----------------------------------
    async loadData() {
      this.loading = true;
      if (this.$route.params.classSectionId) {
        this.classSectionId = this.$route.params.classSectionId;
        this.classSection = await this.getClassSectionForLearning({id: this.classSectionId});
        if (this.classSection) {
          //get vdo set topics
          this.vdoSetTopics = await this.getVdoSetTopicsByFilter({
            vdoSetTopicFilterInput: {
              vdoSetId: this.classSection.vdoSet.id,
              isEnabled: true,
            }
          })
          this.courseOutlineUnitLoading = true;
          this.courseOutlineUnits = await this.prepareCourseOutlineUnits();
          this.courseOutlineUnitLoading = false;
        }
      }
      this.loading = false;
    },
    async prepareCourseOutlineUnits() {
      //create Course Outline Units for Side Panel
      let newCourseOutlineUnits = [];
      let courseOutlineUnits = this.classSection
        .courseOutlineRegistration
        .courseOutline
        .courseOutlineUnits;
      if (courseOutlineUnits && courseOutlineUnits.length > 0) {
        let vdoSetUnits = [];
        if (this.classSection.vdoSet) {
          vdoSetUnits = this.classSection.vdoSet.vdoSetUnits;
        }
        for (let i = 0; i < courseOutlineUnits.length; i++) {
          const item = courseOutlineUnits[i];
          let vdoSetUnit = vdoSetUnits.find(element =>
            element.courseOutlineUnit && element.courseOutlineUnit.id === item.id);

          //filter isEnabled vdoSetTopic
          if(vdoSetUnit && this.vdoSetTopics && this.vdoSetTopics.length > 0) {
            vdoSetUnit.vdoSetTopics = this.vdoSetTopics.filter(e => e.isEnabled && e.vdoSetUnit.id === vdoSetUnit.id);
          }

          let result = {
            ...item,
            vdoSetUnit,
          }
          newCourseOutlineUnits.push(result);
        }
      }
      return newCourseOutlineUnits;
    },
    async createStudentUnitTests(courseOutlineUnit) {
      const payload = {
        studentId: this.studentEnrollDetail.student.id,
        courseOutlineUnitId: courseOutlineUnit.id,
        studentEnrollId: this.studentEnrollDetail.studentEnroll.id,
        studentEnrollDetailId: this.studentEnrollDetail.id,
        academicPeriodId: this.studentEnrollDetail.studentEnroll.academicPeriod.id,
        subjectId: this.studentEnrollDetail.subject.id,
        studentUnitTestInput: {
          studentCode: this.studentEnrollDetail.student.code,
          subjectCode: this.studentEnrollDetail.subject.code,
          periodCode: this.studentEnrollDetail.studentEnroll.periodCode,

          unitSeq: courseOutlineUnit.seq,
          pretestScore: 0,
          pretestMaxScore: courseOutlineUnit.preTestExpectScore,
          pretestQuestionQty: courseOutlineUnit.preTestExpectScore,
          isPretestDone: false,
          posttestScore: 0,
          posttestMaxScore: courseOutlineUnit.postTestExpectScore,
          posttestQuestionQty: courseOutlineUnit.postTestExpectScore,
          isPosttestDone: false,
        },
      };
      let result = await this.addStudentUnitTest(payload);
      if (result) {
        return result;
      }
      return null;
    },
    async createStudentUnitLearns(courseOutlineUnit, vdoSetUnit) {
      const payload = {
        studentEnrollId: this.studentEnrollDetail.studentEnroll.id,
        studentEnrollDetailId: this.studentEnrollDetail.id,
        courseOutlineUnitId: courseOutlineUnit.id,
        vdoSetUnitId: vdoSetUnit.id,
        studentUnitLearnInput: {
          unitSeq: courseOutlineUnit.seq,
          totalVdoLength: vdoSetUnit.totalVdoLength,
          totalLearnTime: 0,
          learnPercent: 0,
        },
      };
      let result = await this.addStudentUnitLearnAndTopic(payload);
      if (result) {
        return result;
      }
      return null;
    },
    async createStudentTopicLearn(studentUnitLearn, vdoSetTopic, vdoSetUnit) {

      let learnTime = 0;
      let learnPercent = 0;
      //fix case have Student unit learn percent = 100 but dont have student topic learn
      if (studentUnitLearn.learnPercent >= 100) {
        learnTime = vdoSetTopic.vdoLength;
        learnPercent = 100;
      }
      const payload = {
        studentUnitLearnId: studentUnitLearn.id,
        studentEnrollDetailId: this.studentEnrollDetail.id,
        vdoSetUnitId: vdoSetUnit.id,
        vdoSetTopicId: vdoSetTopic.id,
        studentTopicLearnInput: {
          vdoLength: vdoSetTopic.vdoLength,
          learnTime: learnTime,
          learnPercent: learnPercent,
        }
      };
      const result = await this.addStudentTopicLearn(payload);
      if (result) {
        return result
      }
      return null
    },
    setCurrentCourseOutlineUnit(unit) {
      this.currentCourseOutlineUnit = unit;
      this.currentCourseOutlineUnitIndex = this.courseOutlineUnits.findIndex(item => item.id === unit.id);
    },
    setCurrentVdoSetTopic(topic) {
      this.currentVdoSetTopic = topic;
      this.currentVdoSetTopicIndex = this.currentCourseOutlineUnit
        .vdoSetUnit
        .vdoSetTopics.findIndex(item => item.id === topic.id);
    },
    async setStudentTopicLearnToVdoSetTopic(studentUnitLearn, vdoSetUnit){
      let studentTopicLearns = studentUnitLearn.studentTopicLearns;
      for (let j = 0; j < vdoSetUnit.vdoSetTopics.length; j++) {
        let vdoSetTopic = vdoSetUnit.vdoSetTopics[j];
        let studentTopicLearn = studentTopicLearns.find(element =>
          element.vdoSetTopic && element.vdoSetTopic.id === vdoSetTopic.id);
        if (!studentTopicLearn) {
          //create missing studentTopicLearn
          studentTopicLearn = await this.createStudentTopicLearn(studentUnitLearn, vdoSetTopic, vdoSetUnit);
        }
        vdoSetUnit.vdoSetTopics[j] = {
          ...vdoSetUnit.vdoSetTopics[j],
          studentTopicLearn,
        }
      }
      return vdoSetUnit;
    },
    clearVdoPanelVariable() {
      this.currentVdoSetTopic = null;
      this.currentVdoSetTopicIndex = null;
      this.keepCounting = false;
    },
    clearUniTestPanelVariable() {
      this.doingExam = false;
      this.examMode = '';
      this.currentStudentUnitTest = null;
      this.currentStudentUnitTestIndex = null;
    },
    setTriggerLoading(val){
      this.triggerLoading = val
    },
    handleWindowResize(event) {
      if (event && !event.isTrusted) {
        return;
      }
      const windowWidth = window.innerWidth;
      if (windowWidth <= 1200) {
        this.isBigScreen = false;
      } else {
        this.isBigScreen = true;
      }
    },
  },
  async beforeMount() {
    EventBus.$emit('toggleNav', 'close');
    await this.loadData();
  },
  async mounted() {
    window.addEventListener('resize', this.handleWindowResize);
    this.handleWindowResize();
  },
  async beforeDestroy() {
    document.removeEventListener('resize', this.handleWindowResize);
    EventBus.$emit('toggleNav', 'open');
  },
}
</script>

<style lang="scss">
#screen {
  @media only screen and (min-width: 1024px) {
    height: calc(var(--vh, 1vh) * 100 - 6rem) !important;
  }
  word-break: break-word !important;
  overflow: hidden;

  & .panels {
    overflow-y: auto;
  }
}

.parentx-static {
  overflow: hidden;
  position: relative;
}

.content-tab-button {
  position: absolute;
  top: 36px;
  right: -6px;
  transition: all ease-in 300ms;
  z-index: 99999;

  & .vs-button-text {
    display: inline-flex;
    align-items: center;
  }

  &.hide {
    right: -114px;
    background: rgba(0, 0, 0, 0.5) !important;
  }
}

.main-panel {
  border-left: 1px solid #eeeeee !important;
  border-right: 1px solid #dddddd !important;
}

.side-panel {
  transition: all ease-out 400ms;
  // width: 0px;

  &.hide {
    width: 0px !important;
    opacity: 0;
  }
}

.panel-fade-enter-active {
  transition: all .3s ease;
}

.panel-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.panel-fade-enter, .panel-fade-leave-to {
  opacity: 0;
}

</style>
